import { z } from "zod";
import { Timestamp } from "./primitives.js";
/**
 * What Mosaic is willing to interrupt the owner for. Deliberately short, because a
 * channel that fires on everything gets muted.
 */
export const NotificationKind = z.enum([
    "situation_opened",
    "stage_advanced",
    "stage_regressed",
    "flag_raised",
    /**
     * A queued `whole`-depth question has an answer. Exists for latency rather than
     * importance: a `navigate` answer streams back with the owner watching, while a
     * `whole` one may land much later.
     */
    "ask_answered",
    /**
     * Nothing raises one, but stored rows may carry it, so the type admits it.
     */
    "test",
]);
/** The channels a notification can be delivered to. */
export const NotificationChannel = z.enum(["mattermost", "discord", "web_push"]);
/** How urgently a notification asks for attention, least to most. */
export const NotificationSeverity = z.enum(["info", "watch", "critical"]);
/**
 * The rendered message, built where the facts are and stored as it will be sent, so it
 * records the moment of the event. Channel adapters format it; they do not compose it.
 */
export const NotificationMessage = z.object({
    title: z.string().min(1).max(300),
    body: z.string().max(2000).nullable().default(null),
    /** Absolute, so a phone notification is one tap from the situation. */
    url: z.string().url().nullable().default(null),
    severity: NotificationSeverity.default("info"),
});
/**
 * A notification as stored, with where it was delivered.
 *
 * `subjectType` and `subjectId` name what it is about, such as a situation or an Ask thread.
 */
export const Notification = z.object({
    id: z.string().uuid(),
    kind: NotificationKind,
    subjectType: z.string().nullable(),
    subjectId: z.string().nullable(),
    message: NotificationMessage,
    createdAt: Timestamp,
    deliveredAt: Timestamp.nullable(),
    channelsDelivered: z.array(z.string()),
});
//# sourceMappingURL=notification.js.map